import { useContext } from 'react';
import { LocCtx } from '../../types';
import { LocalizationContext } from './LocalizationContext';

export const useLocalizationContext = () => useContext<LocCtx>(LocalizationContext);

export const useLocalization = (key: string, params?: (string | number)[]) =>
    useContext<LocCtx>(LocalizationContext).localizationService.get(key, params);
